<template>
  <nav>
    <div class="buckets-container">
      <div v-for="(bucket, index) in buckets" :key="index">
        <div class="card" v-for="(paths, key) in bucket" :key="key">
          
          <ul>
            <li v-for="(path, index) in paths" :key="index">
              <a v-if="work[path]" href="javascript:;" type="text" @click="go(path)">{{ path }}</a>
              <p v-if="work[path]">{{ work[path] }}</p>
            </li>
          </ul>
          
        </div>
      </div>
    </div>
  </nav>
</template>

<style lang="scss" scoped>
    ul ,li , p{
      margin: 0;
      padding:0;
    }
    li {
      margin-left:200px;
      width:100%;
      overflow: hidden;
      padding-left:100px;
      line-height: 160%;
      a {
        float: left;
        margin-left:-100px;
      }
      p {
        float: left;
      }
    }
    dl {
      text-align: left;
    }
</style>

<script>

export default {
  data() {
    return {
      columnCount: Math.floor(document.body.clientWidth / 300),
      work:{
        '/account':'账号体系 -- 冯恒',
        '/aiMatch':'AI匹配 -- 慕晓阳(整合页面 组件开发)',
        '/cdy':'成单易 -- 韩伟月',
        '/employer':'新上雇主 -- 慕晓阳(整合页面 组件开发)',
        '/order':'我的订单 & 简历详情 -- 韩伟月',
        '/pa':'pa派单 -- 慕晓阳(整合页面 组件开发)',
        '/positions':'职位 -- 王兆峰(慕晓阳 筛选组件)',
        '/recommend':'推荐列表 -- 待定',
        '/recruit':'专场 -- 韩伟月',
        '/share':'分享落地页 -- 王兆峰',
        '/subscribe':'我的订阅 -- 冯恒'
      }
    };
  },
  computed: {
    paths() {
      return this.$router.options.routes
        .filter(route => !["/", "/404", "*"].includes(route.path))
        .reduce(
          (ret, route) => [
            ...ret,
            route.path,
            ...(route.children
              ? route.children.map(subRoute => `${route.path}/${subRoute.path}`)
              : [])
          ],
          []
        )
        .sort();
    },
    cardModel() {
      return this.paths.reduce((ret, path) => {
        const key = /\/[\w-]+/.exec(path)[0];

        return ret[key]
          ? {
              ...ret,
              [key]: [...ret[key], path]
            }
          : {
              ...ret,
              [key]: [path]
            };
      }, {});
    },
    buckets() {
      const buckets = Array.apply(null, { length: this.columnCount }).map(
        () => ({})
      );

      Object.entries(this.cardModel).forEach(([key, paths]) => {
        let minIndex = 0;
        let minLength = Infinity;

        buckets.forEach((bucket, index) => {
          const length = Object.values(bucket).reduce(
            (ret, paths) => ret + paths.length,
            0
          );

          if (length < minLength) {
            minIndex = index;
            minLength = length;
          }
        });
        buckets[minIndex][key] = paths;
      });

      return buckets;
    }
  },
  methods: {
    close(){
          if(WeixinJSBridge){
          WeixinJSBridge.call('closeWindow');
        }else{
          window.close();
        };
    },
    go(path) {
      this.$router.push({ path });
    },
    onresize() {
      this.columnCount = Math.floor(document.body.clientWidth / 300);
    }
  },
  mounted() {
    console.log(this.$router.options.routes);
    // fetchList().then(res => {
      //   // console.log(res);
      //   //this.list = response.data.items
      //   //this.listLoading = false
      // });

      // fetchDetail({id:1}).then(res =>{
      //   // console.log('detail',res);
      // });

      // https://www.cnblogs.com/sinosaurus/p/9166543.html
      // const [list, detail] = Promise.all([fetchList(), fetchDetail({id:1})])
      // console.log(list,detail,'alll')
    window.addEventListener("resize", this.onresize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onresize);
  }
};
</script>
